import { Component, OnInit, Inject } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ErrorComponent } from '@angular/synthrone-design/components';

@Component({
  selector: 'app-add-update-feature-variant',
  templateUrl: './add-update-feature-variant.component.html',
  styleUrls: ['./add-update-feature-variant.component.scss']
})
export class AddUpdateFeatureVariantComponent implements OnInit {

  configuration: any = {};
  params: any = {};
  requiredFields: Array<string> = [];
  public submitClicked: boolean;
  public isEdit: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddUpdateFeatureVariantComponent>,
    public dialog: MatDialog
  ) {
    this.submitClicked = false;
    this.isEdit = false;
    this.configuration = this.data.featureConfiguration || {};
    this.params = this.data.clientFeatureConfiguration || {};
  }

  ngOnInit() {
    if (!this.params || Object.keys(this.params).length === 0) {
      this.fillClientFeatureConfigWithDefaults();
    }
    this.setMandatoryTemplateFields();
    if (this.data.id) {
      this.isEdit = true;
    }
    this.requiredFields = Object.keys(this.configuration).filter((el) => {
      if (this.configuration[el].required) {
        return el;
      }
    });
  }

  closeWindow = (param = null) => {
    this.dialogRef.close(param);
  };

  canSubmit = () => {
    let canSubmit = true;
    this.requiredFields.forEach((field) => {
      if (['multiselect', 'select'].includes(this.configuration[field].type)) {
        if (!this.params[field] || this.params[field].length === 0) {
          canSubmit = false;
        }
      } else if (!this.params[field]) {
        canSubmit = false;
      }
    });
    return canSubmit;
  };

  submitFn = () => {
    this.submitClicked = true;
    this.data.callback({
      params: this.params
    }).catch((error: any) => {
        this.submitClicked = false;
        this.showError(error);
        return Observable.throw(error)
      }
    ).subscribe((response) => {
      this.closeWindow(true);
    });
  };


  checkField = (event, param, configuration) => {
    if (configuration[param]['type'] === 'number') {
      if (!event.target.value) {
        this.params[param] = configuration[param]['default'];
        return;
      }
      const max = parseInt(event.target.max);
      const min = parseInt(event.target.min);
      const value = parseInt(event.target.value.match(/\d+/g)[0]);
      this.params[param] = Math.max(min, Math.min(max, value));
    }
  }

  showError(message: string) {
    const dialogRef = this.dialog.open(ErrorComponent, {
      data: {
        message: message
      }
    });
    return dialogRef.afterClosed();
  }

  fillClientFeatureConfigWithDefaults = () => {
    Object.keys(this.configuration).forEach((key) => {
      const featureOption = this.configuration[key];
      switch (featureOption.type) {
        case 'multiselect':
          this.params[key] = featureOption.options
            .filter((option) => option.default)
            .map((option) => option.value);
          break;
        case 'number':
          this.params[key] = featureOption.default;
          break;
        default:
          break;
      }
    });
  }

  setMandatoryTemplateFields = () => {
    if (!this.configuration['reportTemplateFields']) {
      return;
    }
    this.configuration['reportTemplateFields'].options.forEach( option => {
      if (!this.params['reportTemplateFields']) {
        this.params['reportTemplateFields'] = [];
      }
      if (option.mandatory && !this.params['reportTemplateFields'].includes(option.value)) {
        this.params['reportTemplateFields'].push(option.value);
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/add-update-feature-variant/add-update-feature-variant.component.ts